/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *           _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * A service that performs a REST call to fetch the current user from our backend.
 */
export class InitialUserFetchService {
  static init(): Promise< any > {
    // Create the XHR request
    const request = new XMLHttpRequest();

    // Return it as a Promise
    return new Promise((resolve, reject) => {
      // Setup our listener to process compeleted requests
      request.onreadystatechange = function () {
        // Only run if the request is complete
        if (request.readyState !== 4) return;

        // Process the response
        if (request.status >= 200 && request.status < 300) {
          // Convert data string to an object:
          const data = JSON.parse(request.response);
          resolve(data);
        } else {
          reject({
            status: request.status,
            statusText: request.statusText,
          });
        }
      };

      // Create and send a GET request
      request.open('GET', '/b/rest/auth/current');
      request.send();
    });
  }
}
